import React from 'react'

const FolderIcon = ({ size = 24, className = '', style = {} }) => {
  return (
    <svg 
      width={size} 
      height={size} 
      viewBox="0 0 24 24" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <linearGradient id="folderGradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="rgba(255, 200, 120, 1)" />
          <stop offset="100%" stopColor="rgba(220, 160, 80, 1)" />
        </linearGradient>
        <filter id="folderGlow">
          <feGaussianBlur stdDeviation="1" result="coloredBlur"/>
          <feMerge>
            <feMergeNode in="coloredBlur"/>
            <feMergeNode in="SourceGraphic"/>
          </feMerge>
        </filter>
      </defs>
      
      {/* Folder back */}
      <path 
        d="M3 7v11a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2h-7l-2-2H5a2 2 0 0 0-2 2z"
        fill="url(#folderGradient)"
        filter="url(#folderGlow)"
      />
      
      {/* Folder tab */}
      <path 
        d="M3 7h7l2-2h7a2 2 0 0 1 2 2v2H3V7z"
        fill="rgba(255, 220, 140, 0.8)"
      />
      
      {/* Highlight */}
      <path 
        d="M5 9h14v8H5V9z"
        fill="rgba(255, 255, 255, 0.1)"
      />
    </svg>
  )
}

export default FolderIcon
